/** Where a customer held back by the design-month gate can write to Cadstrom. */
export const DESIGN_MONTH_GATE_CONTACT_EMAIL = 'info@cadstrom.io';

/**
 * The booking page the gate embeds so a customer can schedule a call with Cadstrom, taken from
 * the build's environment. Null when none is configured, in which case the gate offers email only.
 */
const configuredSchedulingUrl = import.meta.env.VITE_SALES_SCHEDULING_URL?.trim() ?? '';
export const DESIGN_MONTH_GATE_SCHEDULING_URL: string | null =
	configuredSchedulingUrl === '' ? null : configuredSchedulingUrl;

/** Who is booking, so Calendly can fill in its form for them. */
export interface SchedulingPrefill {
	name?: string;
	email?: string;
}

/**
 * The address to load a Calendly booking page from when it is embedded inline on `embedDomain`,
 * with the booking form filled in from `prefill`. Parameters already on the booking URL are
 * kept, and a name that only repeats the email is left out.
 *
 * @param schedulingUrl - The Calendly booking page.
 * @param embedDomain - The host the page is embedded on, as Calendly expects it.
 * @param prefill - The booker's details, where known.
 * @returns The inline-embed URL.
 */
export function buildSchedulingEmbedUrl(
	schedulingUrl: string,
	embedDomain: string,
	prefill: SchedulingPrefill = {},
): string {
	const url = new URL(schedulingUrl);
	url.searchParams.set('embed_domain', embedDomain);
	url.searchParams.set('embed_type', 'Inline');
	url.searchParams.set('hide_gdpr_banner', '1');
	const { name, email } = prefill;
	if (name !== undefined && name !== '' && name !== email) {
		url.searchParams.set('name', name);
	}
	if (email !== undefined && email !== '') {
		url.searchParams.set('email', email);
	}
	return url.toString();
}
